import { useSelector } from 'react-redux';
import { getSessionStorage, removeSessionStorage, setSessionStorage } from '../../common/common';
import { useOpenPixel } from './useOpenPixel';
import { useEffect } from 'react';
import appConfig from '../../config/config';

export const useTrackUserActivity = () => {
  const openPixelInitialize = useOpenPixel();
  useEffect(() => {
    openPixelInitialize(
      window,
      document,
      window['opix'],
      'opix',
      `${appConfig.apiLoc}${process.env.REACT_APP_OPIX_REPORTING_ENDPOINT}`,
      1
    );
  }, []);

  const current_menu = useSelector((state) => state.common.current_menu);
  const opix = window && window['opix'];

  function userActivityTracker(inView, item, typeOfItem, pageId = 0) {
    var { type_id, type, survey_id, sponsor_id, id, session_id } = item || {};
    if (type === 'survey') type_id = survey_id;
    else if (type === 'training') type_id = id;
    else if (type === 'session') type_id = session_id;
    if (inView) {
      const payload = {
        page: current_menu,
        pageId: pageId,
        content_type: type,
        content_id: type_id,
        sponsor_id: sponsor_id
      };
      // opix('event', `${type}_${typeOfItem}`, payload);

      var previousAnalytics = JSON.parse(getSessionStorage('analytics_sent', 'null'));
      if (previousAnalytics && previousAnalytics.length > 0) {
        var findIndex = previousAnalytics.indexOf(payload);
        if (findIndex === -1) {
          previousAnalytics.push(payload);
          setSessionStorage('analytics_sent', JSON.stringify(previousAnalytics));
        }
      } else {
        setSessionStorage('analytics_sent', JSON.stringify([payload]));
        // opix('event', `${type}_${typeOfItem}`, payload);
      }

      if (JSON.parse(getSessionStorage('analytics_sent'))?.length > 4) {
        opix('event', ``, getSessionStorage('analytics_sent'));

        removeSessionStorage('analytics_sent');
      }
    }
  }

  // function userClickActivityTracker(item){
  //     var { type_id, type, survey_id ,sponsor_id} = item || {};
  //     if (type === 'survey') type_id = survey_id;
  //     else if (type==='training') type_id = id;
  //     const payload = {
  //         page: current_menu,
  //         pageId: 0,
  //         content_type: type,
  //         content_id: type_id,
  //         sponsor_id: sponsor_id,
  //       }
  //     opix('event', `${type}_${typeOfItem}`, payload);

  // }

  return {
    userActivityTracker
  };
};
